import React, { useState } from "react";
import { useQuery } from "react-query";
import { apirequest } from "../../../../API/api";
import { endpoint } from "../../../../API/config";
import testIcon from "../../../../assets/icons/test.svg";
import useDebounce from "../../../../hooks/useDebounce";
import FilterFunctionlity from "../../../filterFunctionality/FilterFunctionlity";
import Loader from "../../../global/loader/Loader";
import Header from "../../../header/Header";
import BackendTableSearch from "../../../table/BackendTableSearch";
import CourseTable from "../../../table/CourseTable";
import TablePagination from "../../../table/TablePagination";

const AdvertisementListing = () => {
  const column = [
    { col: "0", width: "45%" },
    { col: "1", width: "50%" },
    { col: "2", width: "" },
  ];

  const [searchValue, setSearchValue] = useState("");
  const debouncedSearch = useDebounce(searchValue, 500);
  const {
    data: advertisementData,
    isSuccess,
    isError,
    isLoading,
  } = useQuery(
    [endpoint.advertisementListingApi.key, debouncedSearch],
    () =>
      apirequest({
        method: "post",
        url: endpoint.advertisementListingApi.addr,
        data: {
          adminimspin: "IMS0000394697",
          searchKeyword: debouncedSearch,
        },
      }),
    {
      retry: 1,
    }
  );

  const [currentPage, setCurrentPage] = useState(1);
  const dataPerPage = 10;
  const indexOfLastItem = currentPage * dataPerPage;
  const indexOfFirstItem = indexOfLastItem - dataPerPage;
  const paginate = (pageNumbers) => {
    setCurrentPage(pageNumbers);
  };
  return (
    <div>
      <Header />

      <div className="p-8">
        <header className="flex justify-between px-6 mb-5">
          <FilterFunctionlity dropdownData={[]} />
          <BackendTableSearch
            setSearchValue={setSearchValue}
            searchValue={searchValue}
            setCurrentPage={setCurrentPage}
          />
        </header>
        {isLoading && <Loader />}
        {isSuccess && (
          <>
            <section>
              <CourseTable
                currentData={advertisementData?.data?.data?.courseList
                  .filter((item) => item.isActive === "1")
                  .slice(indexOfFirstItem, indexOfLastItem)}
                colIcon={testIcon}
                column={column}
              />
            </section>
            <footer>
              <TablePagination
                data={advertisementData?.data?.data?.courseList.filter(
                  (item) => item.isActive === "1"
                )}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                paginate={paginate}
                dataPerPage={dataPerPage}
              />
            </footer>
          </>
        )}
      </div>

      {isError && (
        <span className="text-base text-red-600 flex justify-center">
          No Record found
        </span>
      )}
    </div>
  );
};

export default AdvertisementListing;
